import { createSelector } from 'reselect';

// Selectors
const selectCustomOptions = ({
    customOptions = {
        selectedCustomOptions: [],
        options: { fields: [] },
    },
}) => customOptions;
const select2ObjArg = (smth, secondArg = {}) => secondArg;

/* istanbul ignore next */
const selectCustomOptionsInitialValues = createSelector(
    [selectCustomOptions, select2ObjArg],
    ({ selectedCustomOptions, options }, query) => {
        const result = {};
        options &&
            options.fields.forEach((field) => {
                if (query[field.name]) {
                    result[field.type] = query[field.name];
                }
                const customOptionSelected = selectedCustomOptions
                    ? selectedCustomOptions.filter(
                          (selectedOption) => selectedOption.type === field.name
                      )
                    : [];
                if (customOptionSelected.length) {
                    result[field.type] = customOptionSelected[0].value;
                }
            });
        return result;
    }
);

export default selectCustomOptionsInitialValues;
